import React, { useState } from "react";
import "../../Styles/Mp4Table.css";
import { useNavigate } from "react-router-dom";

function AdminMp4Table() {
  const navigate = useNavigate();

  const initialData = [
    {
      id: 1,
      title: "Development Works in Kandukur",
      desc: "Overview of ongoing development works and infrastructure projects in Kandukur constituency.",
      thumbnail:
        "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=300&h=200&fit=crop",
      duration: "05:36",
      youtubeUrl: "https://www.youtube.com/embed/abc123",
      youtubeHandle: "youtu.be/abc123",
      status: "Active",
      uploadDate: "20-07-2026",
      uploadTime: "10:30 AM",
    },
    {
      id: 2,
      title: "Kandukur Development Works",
      desc: "Highlights of recent development initiatives and public welfare activities.",
      thumbnail:
        "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=300&h=200&fit=crop",
      duration: "07:12",
      youtubeUrl: "https://www.youtube.com/embed/xyz456",
      youtubeHandle: "youtu.be/xyz456",
      status: "Active",
      uploadDate: "22-07-2026",
      uploadTime: "03:15 PM",
    },
  ];

  const [videos, setVideos] = useState(initialData);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All Status");
  const [dateFilter, setDateFilter] = useState("All Dates");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 12;

  const resetFilters = () => {
    setSearch("");
    setStatus("All Status");
    setDateFilter("All Dates");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const filteredVideos = videos.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" ||
      item.title.toLowerCase().includes(searchLower) ||
      item.desc.toLowerCase().includes(searchLower);

    const matchesStatus = status === "All Status" || item.status === status;

    let matchesDate = true;
    if (dateFilter === "This Month") {
      const today = new Date();
      const [day, month, year] = item.uploadDate.split("-").map(Number);
      matchesDate =
        month === today.getMonth() + 1 && year === today.getFullYear();
    } else if (dateFilter === "This Year") {
      const today = new Date();
      const [, , year] = item.uploadDate.split("-").map(Number);
      matchesDate = year === today.getFullYear();
    }

    return matchesSearch && matchesStatus && matchesDate;
  });

  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setVideos((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  const totalVideos = videos.length;
  const activeVideos = videos.filter((v) => v.status === "Active").length;
  const totalViews = "12.4K";

  const thisMonth = videos.filter((v) => {
    const today = new Date();
    const [day, month, year] = v.uploadDate.split("-").map(Number);
    return month === today.getMonth() + 1 && year === today.getFullYear();
  }).length;

  return (
    <div className="vid123-page">
      <div className="vid123-header">
        <div>
          <h2 className="vid123-title">Video Gallery</h2>
          <p className="vid123-subtitle">
            Manage and organize all uploaded videos
          </p>
        </div>

        <button
          className="vid123-add-btn"
          onClick={() => navigate("/AdminDashboard/mp4-form")}
        >
          <span className="vid123-add-icon">+</span> Add New Video
        </button>
      </div>

      <div className="vid123-stats-grid">
        <div className="vid123-stat-card vid123-stat-card-green">
          <div className="vid123-stat-icon vid123-stat-icon-green">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
          <div className="vid123-stat-info">
            <span className="vid123-stat-label">Total Videos</span>
            <span className="vid123-stat-value">{totalVideos}</span>
            <span className="vid123-stat-sub">All time videos</span>
          </div>
        </div>

        <div className="vid123-stat-card vid123-stat-card-blue">
          <div className="vid123-stat-icon vid123-stat-icon-blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="5" width="15" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M17 9l5-3v12l-5-3" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="vid123-stat-info">
            <span className="vid123-stat-label">Active Videos</span>
            <span className="vid123-stat-value">{activeVideos}</span>
            <span className="vid123-stat-sub">Currently active</span>
          </div>
        </div>

        <div className="vid123-stat-card vid123-stat-card-orange">
          <div className="vid123-stat-icon vid123-stat-icon-orange">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </div>
          <div className="vid123-stat-info">
            <span className="vid123-stat-label">Total Views</span>
            <span className="vid123-stat-value">{totalViews}</span>
            <span className="vid123-stat-sub">All time views</span>
          </div>
        </div>

        <div className="vid123-stat-card vid123-stat-card-purple">
          <div className="vid123-stat-icon vid123-stat-icon-purple">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="vid123-stat-info">
            <span className="vid123-stat-label">This Month</span>
            <span className="vid123-stat-value">{thisMonth}</span>
            <span className="vid123-stat-sub">New videos added</span>
          </div>
        </div>
      </div>

      <div className="vid123-filters">
        <div className="vid123-search-box">
          <input
            type="text"
            placeholder="Search by video title..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <select
          className="vid123-select"
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <select
          className="vid123-select"
          value={dateFilter}
          onChange={(e) => {
            setDateFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Dates</option>
          <option>This Month</option>
          <option>This Year</option>
        </select>

        <button className="vid123-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Clear Filters
        </button>
      </div>

      <div className="vid123-table-wrapper">
        <table className="vid123-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Video Details</th>
              <th>Status</th>
              <th>Upload Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredVideos.length === 0 ? (
              <tr>
                <td colSpan="5" className="vid123-no-data">
                  No videos found.
                </td>
              </tr>
            ) : (
              filteredVideos.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>
                    <div className="vid123-video-cell">
                      <div className="vid123-thumb-wrap">
                        <img
                          src={item.thumbnail}
                          alt={item.title}
                          className="vid123-thumb-img"
                        />
                        <div className="vid123-thumb-overlay">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                        <span className="vid123-thumb-duration">
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                          {item.duration}
                        </span>
                      </div>

                      <div className="vid123-video-info">
                        <div className="vid123-video-title">{item.title}</div>
                        <div className="vid123-video-desc">{item.desc}</div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <span
                      className={`vid123-status-badge ${
                        item.status === "Active"
                          ? "vid123-status-active"
                          : "vid123-status-inactive"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div className="vid123-date-cell">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                      <div>
                        <div>{item.uploadDate}</div>
                        <div className="vid123-time-text">{item.uploadTime}</div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <button className="vid123-edit-btn" onClick={() => openEditModal(item)}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="vid123-pagination-bar">
        <span className="vid123-pagination-info">
          Showing 1 to {filteredVideos.length} of {totalVideos} videos
        </span>

        <div className="vid123-pagination-controls">
          <button
            className="vid123-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`vid123-page-num ${currentPage === p ? "vid123-active" : ""}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="vid123-page-dots">...</span>

          <button
            className={`vid123-page-num ${currentPage === totalPages ? "vid123-active" : ""}`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="vid123-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {showEditModal && editItem && (
        <div className="vid123-modal-overlay" onClick={closeEditModal}>
          <div className="vid123-modal" onClick={(e) => e.stopPropagation()}>
            <div className="vid123-modal-header">
              <h3>Edit Video</h3>
              <button className="vid123-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="vid123-modal-body" onSubmit={handleEditSave}>
              <div className="vid123-form-group">
                <label>Video Title</label>
                <input
                  type="text"
                  name="title"
                  value={editItem.title}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="vid123-form-group">
                <label>Description</label>
                <textarea
                  name="desc"
                  value={editItem.desc}
                  onChange={handleEditChange}
                  rows="3"
                />
              </div>

              <div className="vid123-form-group">
                <label>YouTube URL</label>
                <input
                  type="text"
                  name="youtubeUrl"
                  value={editItem.youtubeUrl}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="vid123-form-row">
                <div className="vid123-form-group">
                  <label>Duration</label>
                  <input
                    type="text"
                    name="duration"
                    placeholder="MM:SS"
                    value={editItem.duration}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="vid123-form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={editItem.status}
                    onChange={handleEditChange}
                  >
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="vid123-form-row">
                <div className="vid123-form-group">
                  <label>Upload Date</label>
                  <input
                    type="text"
                    name="uploadDate"
                    placeholder="DD-MM-YYYY"
                    value={editItem.uploadDate}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="vid123-form-group">
                  <label>Upload Time</label>
                  <input
                    type="text"
                    name="uploadTime"
                    placeholder="hh:mm AM/PM"
                    value={editItem.uploadTime}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="vid123-modal-footer">
                <button
                  type="button"
                  className="vid123-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="vid123-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminMp4Table;